import Cookies from 'js-cookie';

/**
 * Handles the tracking logic for the Help Me Choose
 */
class ChooserTrackingService {

  constructor() {
    if (!ChooserTrackingService._instance) {
      ChooserTrackingService._instance = this;
    }

    // Initialize variables.
    this._initialStep = 'begin-journey';
    this._stepCookieName = 'hmc-journey-step-tracker';
    this._visitsCounterCookieName = 'hmc-journey-visits-tracker';

    // Event listeners.
    this._handleOnPageLoad();

    // Return this instance.
    return ChooserTrackingService._instance;
  }

  setTrackingStep(stepName) {
    if (stepName === 'hmc-product-selection' || this._getPageVisits() <= 1) {
      // Steps are as follows:
      //  1. hmc-product-selection
      //  2. product-list-selection
      //  3. product-detail-view
      switch (stepName) {
        case 'hmc-product-selection':
          if (this.getCurrentStep() === 'begin-journey') {
            this.setCurrentStep('hmc-product-selection');
            this._setPageVisits(0);
          }
          else {
            this.setCurrentStep(this._initialStep);
          }

          break;

        case 'product-list-selection':
          if (this.getCurrentStep() === 'hmc-product-selection') {
            this.setCurrentStep('product-list-selection');
            this._setPageVisits(0);
          }
          else {
            this.setCurrentStep(this._initialStep);
          }

          break;

        case 'product-detail-view':
          if (this.getCurrentStep() === 'product-list-selection') {
            // We are at the final step. Look for the request samples form on the page and replace the
            // product code value.
            let productCodeHiddenInput = document.querySelector('.form-submit--request-samples-referring-page input[name=form_id]');

            if (productCodeHiddenInput) {
              productCodeHiddenInput.value = 'helpChoose';
            }

          }
          else {
            this.setCurrentStep(this._initialStep);
          }

          break;
      }
    }

  }

  setCurrentStep(stepName) {
    Cookies.set(this._stepCookieName, stepName);
  }

  getCurrentStep() {
    return Cookies.get(this._stepCookieName);
  }

  _setPageVisits(pageVisits) {
    Cookies.set(this._visitsCounterCookieName, pageVisits);
  }

  _getPageVisits() {
    return parseInt(Cookies.get(this._visitsCounterCookieName));
  }

  _incrementPageVisits() {
    let currentPageVisits = this._getPageVisits();

    if (isNaN(currentPageVisits)) {
      currentPageVisits = 0;
    }

    this._setPageVisits(currentPageVisits  + 1);
  }

  _handleOnPageLoad() {
    // Increase the page visit number.
    this._incrementPageVisits();

    // Ensure the step cookie is present.
    if (!this.getCurrentStep() || this._getPageVisits() > 1) {
      this.setCurrentStep(this._initialStep);
    }

    // This is for the product page only.
    if (document.querySelector('.page-type-product')) {
      this.setTrackingStep('product-detail-view');

      const appObserver = new MutationObserver(() => {
        this.setTrackingStep('product-detail-view');
      });

      appObserver.observe(
        document,
        { attributes: false, childList: true, subtree: true }
      );

    }
  }

}



// Create a new instance.
const instance = new ChooserTrackingService();

// Export the instance rather than the class.
export default instance;